import {
  Button,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  message,
  Modal,
  RadioChangeEvent,
  Row,
  Select,
} from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { Moment } from 'moment';
import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { isEmpty } from 'underscore';
import Api from '../../../api/Api';
import { Label } from '../../../components/Label/Label';
import { DownloadCheckboxKey, openEULAPdf, openPrivatePolicy } from '../../../generic/common';
import { DTFullFormat } from '../../../generic/StaticVariable';
import { StoreContext } from '../../../store/store';
import { DownloadInfoItem } from '../../../typings/analytics';
import { IEnrichedMetadata } from '../../../typings/metadata';
import { getCategoryPostfix } from '../../PointHelper';
import { getPointNamInCartError } from '../ResultPanel';
import styles from '../Style/DatasetInfo.module.scss';
import { PREPROCESSED_ANALYTICS } from './AnalyticsPanel';
import { ReactComponent as Metadata } from '../../../assets/icon/Metadata.svg';
import { userGroupValidation } from '../../../generic/userGroupValidation';
import {
  DataAccess,
  SubscriptionType,
  WaterdataGroup,
} from '../../../typings/userGroupPermissions';
import LoadingContext from '../../../context/loadingContext/LoadingContext';
import { withLoading } from '../../../components/Loading/withLoading';
import { MarkerItem, overlay } from '../../../typings/home';
import { BuyButton, DownloadButton } from './DatasetInfoButtons';
import { createDownloadOrderString } from '../../../generic/createDownloadOrderString';
import { useUserProvider } from '../../../generic/hooks';
import DownloadDataModal from '../../Home/Component/DownloadDataModal';
import { multiPolygon, points } from '@turf/helpers';
import pointsWithinPolygon from '@turf/points-within-polygon';
import { Position } from 'deck.gl';
import { DATASET_CATEGORIES } from '../../../generic/filterBestDataset';
import { useIsTnw } from '../../../generic/hooks';
import { useData } from '../Store/DatasetContext';

const { RangePicker } = DatePicker;
const THOWDWAVESPECTRA = '2D Wave Spectra'

export default function DatasetInfo(props: {
  item: DownloadInfoItem; //Best datasets of one categotry (Waves, Ocean, Atmosphere)
  coords: number[];
  onMeshControl: (value: string) => any;
  onRemoveProductFromCart: (pointName: string, category: string) => any;
  onAddProductToCart: (
    item: DownloadInfoItem,
    pointName: string,
    category: string,
    orderId: string,
    price: number,
    coordinates: number[]
  ) => Promise<boolean>;
  downloadItems: DownloadInfoItem[];
  label: string;
  disableDownload: boolean;
  setDisableDownload: React.Dispatch<React.SetStateAction<boolean>>;
  setDatasetIsOfflineWarningVisible: React.Dispatch<React.SetStateAction<boolean>>;
  icon?: JSX.Element;
  namePanel: string,
}) {
  const context = useContext(StoreContext);
  const loadingContext = useContext(LoadingContext);
  const { state, dispatch } = useData()
  const history = useHistory()
  const location = useLocation()

  const dateFormatList = ['YYYY-MM-DD', 'YYYY-MM-DD'];
  const [cartLoading, setCartLoading] = useState<boolean>(false);
  const [addedToCart, setAddedToCart] = useState<boolean>(false);
  const [isTNSDatasetWarningVisible, setIsTNSDatasetWarningVisible] =
    useState(false);
  const [isDownloadModalVisible, setIsDownloadModalVisible] = useState(false);
  const [hasDatasets, setHasDatasets] = useState(false);
  const [isAuthorized, showAssociatedCompanyWarning] = useUserProvider();
  const [price, setPrice] = useState(999);
  const [showDownloadButton, setShowDownloadButton] = useState(false);

  const [
    showCancelDownloadButtonParameters,
    setShowCancelDownloadButtonParameters,
  ] = useState(false);
  const [
    showCancelDownloadButton2DSpectre,
    setShowCancelDownloadButton2DSpectre,
  ] = useState(false);
  const [checkPolicy, setCheckPolicy] = useState<boolean>(false);
  const [showWarn, setShowWarn] = useState<boolean>(false);
  const [isDownloadSpectraModalVisible, setIsDownloadSpectraModalVisible] = useState<boolean>(false);
  const isTnw = useIsTnw(props.item.datasetId);
  const point = context.markerCollections.find((x) => x.active);
  const activePointMetadata = state.pointsMetadata[point?.id!]?.datasets[props.item.datasetId]

  useEffect(() => {
    prepareData();
  }, []);

  useEffect(() => {
    if (point && point.label) {
      let isInCart = false;
      const shoppingItemsOfPoint = context.shoppingItems[point.label];
      if (shoppingItemsOfPoint) {
        const category = shoppingItemsOfPoint[props.label];
        if (category) {
          const sameDataset = category.dataset_id === props.item.datasetId;
          if (sameDataset) {
            // Take also coordinates into account to distinguish from points with same name and dataset from previous sessions
            isInCart =
              category.location.replace(' ', '') === point.coordinates.join();
          }
        }
      }
      setAddedToCart(isInCart);
    }
  }, [
    context.shoppingItems,
    props.item.datasetId,
    props.label,
    point && point.label,
  ]);

  useEffect(() => {
    if (props.item && props.item.datasetId && props.coords) {
      const isMounted = { current: true };
      withLoading(getParameters, loadingContext, {
        isMounted,
        source: 'DownloadInfo.tsx - getParameters',
      });

      // Cleanup function
      return () => {
        isMounted.current = false; // Set the flag to false when the component is unmounted
      };
    }
  }, [props.item && props.item.datasetId, props.coords]);

  useEffect(() => {
    setHasDatasets(props.item.options.length > 0);
  }, [props.item && props.item.options]);

  const [datasetIsOffline, setDatasetIsOffline] = useState(false);
  useEffect(() => {
    prepareData();
  }, [props.item && props.item.datasetId, props.coords]);

  const prepareData = React.useCallback(() => {
    const checkForReports = async (item: DownloadInfoItem) => {
      const metaData = await Api.metadata.getMetadata(item.datasetId);
      dispatch({
        type: 'SET_DATASET', payload: {
          pointId: point?.id!,
          datasetId: item.datasetId,
          metadata: metaData,
          label: point?.label!
        }
      });
      dispatch({
        type: 'SET_RADIO_KEY', payload: {
          pointId: point?.id!,
          datasetId: item.datasetId,
          radioKey: item.radioKey,
          label: point?.label!

        }
      });
      dispatch({
        type: 'SET_LABEL', payload: {
          pointId: point?.id!,
          label: point?.label!,
        }
      });
      dispatch({
        type: 'SET_BEST_DATASET', payload: {
          pointId: point?.id!,
          label: point?.label!,
          datasetId: item.datasetId,
          bestDataset: props.item.options
        }
      });
      setDatasetIsOffline(metaData && metaData.IsOffline ? true : false);
      const analyticDefs =
        metaData && metaData.AnalyticsDefinition
          ? metaData.AnalyticsDefinition.split('|')
          : '';
      const includesPreprocessed = analyticDefs.find(
        (analytic: string) =>
          analytic === PREPROCESSED_ANALYTICS.XLS || analytic === 'XLS'
      );

      dispatch({
        type: 'SET_DATASET_IS_OFFLINE', payload: {
          pointId: point?.id!,
          datasetId: item.datasetId,
          isOffline: metaData && metaData.IsOffline ? true : false,
          label: point?.label!
        }
      });

      dispatch({
        type: 'SET_HAS_REPORTS', payload: {
          pointId: point?.id!,
          datasetId: item.datasetId,
          hasReports: includesPreprocessed !== undefined,
          label: point?.label!
        }
      });

      if (metaData && metaData.TimeDefinition) {
        const userGroupPermissions = userGroupValidation(
          context?.user?.waterdataGroup
            ? WaterdataGroup[context.user.waterdataGroup as WaterdataGroup]
            : null,
          context?.user?.subscriptionType
            ? SubscriptionType[
            context.user.subscriptionType as SubscriptionType
            ]
            : null,
          metaData.TimeDefinition,
          context?.user?.confidentialDatasetIds
        );
        context.setUserGroupPermissions(userGroupPermissions);
        if (userGroupPermissions?.dataAccess === DataAccess.download) {
          setShowDownloadButton(
            userGroupPermissions.dataAccess === DataAccess.download
          );
        }
        dispatch({
          type: 'SET_USER_GROUP_PERMISSIONS', payload: {
            pointId: point?.id!,
            datasetId: item.datasetId,
            userGroupPermissions: userGroupPermissions,
            label: point?.label!
          }
        });

        if (!(!context.overridePointData &&
          item.dateRange &&
          userGroupPermissions?.dateRange &&
          item.dateRange[0].isSameOrAfter(userGroupPermissions?.dateRange[0]) &&
          item.dateRange[1].isSameOrBefore(userGroupPermissions?.dateRange[1]))) {
          onDateChange(userGroupPermissions?.dateRange);
        }
        else {
          onDateChange(item?.dateRange);
        }
      }
    };

    const showTNSWarning = (datasetId: string) => {
      const tns = [''];
      if (tns.includes(datasetId)) {
        let showWarning = true;
        const warningSeenDay = localStorage.getItem('tns');
        localStorage.setItem('tns', Date.now().toString());
        if (warningSeenDay) {
          const lastseenDate = Number(warningSeenDay);
          if (!isNaN(lastseenDate)) {
            const secondsPast = Date.now() - lastseenDate / 1000;
            showWarning = false;
            if (secondsPast > 86400) {
              showWarning = false;
            }
          }
        }
        setIsTNSDatasetWarningVisible(showWarning);
      }
    };

    const dataIsFree = async (datasetId: string) => {
      const response = await Api.moodV2Order.checkDirectDownload(datasetId);
      setShowDownloadButton(response?.Result ? true : false);
    };

    props.item.datasetId &&
      withLoading(() => showTNSWarning(props.item.datasetId), loadingContext, {
        source: 'DownloadInfo.tsx - showTNSWarning',
      });
    props.item.datasetId &&
      withLoading(() => checkForReports(props.item), loadingContext, {
        source: 'DownloadInfo.tsx - checkForReports',
      });
    props.item.datasetId &&
      withLoading(() => dataIsFree(props.item.datasetId), loadingContext, {
        source: 'DownloadInfo.tsx - dataIsFree',
      });
  }, [props.item && props.item.datasetId, context.user, props.coords]);

  // show metadata info
  function onShowMetadata() {
    if (isEmpty(props.item.datasetId)) {
      return;
    }
    context.setSearchId(props.item.datasetId);
    context.setShowSearch(true);
  }

  function changeDataset(newDataset: string) {
    const tempActiveKey = point && context.activeCategoryKey ? context.activeCategoryKey[point.id] : DownloadCheckboxKey.SW
    const item = {
      datasetId: props.item.datasetId,
      dateRange: props.item.dateRange,
      radioKey: props.item.radioKey,
      options: props.item.options,
    }
    props.downloadItems.forEach(element => {
      const findDataset = element.options.find((dataset) => {
        return dataset.id === newDataset
      })
      if (findDataset) {
        item.radioKey = element.radioKey
        item.options = element.options
        item.dateRange = element.dateRange
      }
    });
    handleChangePanelCategory(item.radioKey)
    const obj = Object.assign({}, item, { datasetId: newDataset });

    onDatasetValueChange(obj);

    if (point !== undefined) {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set(item.radioKey, newDataset);
      history.push(`/?${searchParams.toString()}`);
      point.dataset = newDataset;
      context.setMarkerCollections([...context.markerCollections]);
      if (point.ctrlValue.meshEnable) {
        props.onMeshControl(newDataset);
      }
      const activeKey = Object.keys(state.pointsMetadata[point?.id!]?.datasets)
      let oldDataset = props.item.datasetId
      if (tempActiveKey !== item.radioKey) {
        activeKey.forEach(element => {
          const findDataset = item.options.find((dataset) => dataset.id === element)
          if (findDataset) {
            oldDataset = findDataset.id
          }
        });
      }
      dispatch({
        type: 'REPLACE_DATASET_ID', payload: {
          pointId: point?.id!,
          oldId: oldDataset,
          newId: newDataset
        }
      });

    }
  }

  function onDatasetChange(value: string) {
    const datasetTask = context.enrichedMetadata.find(
      (task: IEnrichedMetadata) =>
        task.DatasetId === props.item.datasetId &&
        task.CoordinatesString === point?.coordinates.join()
    );
    if (datasetTask === undefined) {
      // The user hasn't triggered full extraction for current dataset yet
      withLoading(() => changeDataset(value), loadingContext, {
        source: 'DownloadInfo.tsx - changeDataset',
      });
    } else {
      // We warn as the user will loose Analytics and Validations
      dispatch({
        type: 'SET_TEMP_DATASET', payload: {
          pointId: point?.id!,
          datasetId: props.item.datasetId,
          label: point?.label!,
          name: value
        }
      });
      context.setIsChangeDatasetWarningVisible((prevState: { [key: string]: boolean }) => ({
        ...prevState,
        [props.namePanel]: true
      }));
    }
  }

  // * depth and cell size
  async function getParameters(
    options: { isMounted?: { current: boolean } } = {}
  ) {
    const { isMounted } = options;
    const [depth, cellSize] = await Api.detail.getWaterDepthAndCell(
      props.coords,
      props.item.datasetId
    );

    dispatch({
      type: 'SET_DEPTH', payload: {
        pointId: point?.id!,
        datasetId: props.item.datasetId,
        depth: depth === null ? 'empty' : depth.toString(),
        label: point?.label!
      }
    });

    dispatch({
      type: 'SET_CELL_SIZE', payload: {
        pointId: point?.id!,
        datasetId: props.item.datasetId,
        cellSize: cellSize === null ? 'empty' : cellSize.toString(),
        label: point?.label!
      }
    });

    if (isMounted?.current) {
      if (depth == null) {
        context.setDepth((prevState: { [key: string]: boolean }) => ({
          ...prevState,
          [props.namePanel]: 'empty'
        }));
      } else {
        context.setDepth((prevState: { [key: string]: boolean }) => ({
          ...prevState,
          [props.namePanel]: depth
        }));
      }

      if (cellSize == null) {
        context.setCellSize((prevState: { [key: string]: boolean }) => ({
          ...prevState,
          [props.namePanel]: 'empty'
        }));
      } else {
        context.setCellSize((prevState: { [key: string]: boolean }) => ({
          ...prevState,
          [props.namePanel]: cellSize
        }));
      }
    }
  }

  async function getPrice(
    startDate: string,
    endDate: string
  ) {
    if (isEmpty(props.item && props.item.datasetId)) {
      return;
    }
    const response = await Api.price.GetDatasetPriceByPeriod(
      props.item.datasetId,
      startDate,
      endDate
    );
    if (response && response.Result !== null && response.Result.Price !== null) {
      dispatch({
        type: 'SET_PRICE', payload: {
          pointId: point?.id!,
          datasetId: props.item.datasetId,
          price: response.Result.Price,
          label: point?.label!,
        }
      });
      setPrice(response.Result.Price);
    }
    if (response.Error !== null) {
      const errorMessage = response.Error.ErrorMessage
        ? response.Error.ErrorMessage
        : 'Failed to calculate the price';
      message.error(errorMessage);
      dispatch({
        type: 'SET_PRICE', payload: {
          pointId: point?.id!,
          datasetId: props.item.datasetId,
          price: 999,
          label: point?.label!,
        }
      });
      setPrice(999);
    }
  }

  const handleTNSDatasetWarningClose = () => {
    setIsTNSDatasetWarningVisible(false);
  };

  const handleChangeDatasetWarningOk = useCallback(() => {
    context.setIsChangeDatasetWarningVisible((prevState: { [key: string]: boolean }) => ({
      ...prevState,
      [props.namePanel]: false
    }));
    withLoading(
      () => changeDataset(activePointMetadata?.tempDatasetName ?? ''),
      loadingContext,
      { source: 'DownloadInfo.tsx - changeDataset' });
  }, [activePointMetadata?.tempDatasetName]);

  const handleChangeDatasetWarningCancel = () => {
    dispatch({
      type: 'SET_TEMP_DATASET', payload: {
        pointId: point?.id!,
        datasetId: props.item.datasetId,
        label: point?.label!,
        name: ''
      }
    });
    context.setIsChangeDatasetWarningVisible((prevState: { [key: string]: boolean }) => ({
      ...prevState,
      [props.namePanel]: false
    }));
  };

  const handleDownloadModalCancel = () => {
    setIsDownloadModalVisible(false);
    resetDownloadProcess();
  };

  function onDateChange(value: any) {
    const startDate = value[0];
    const endDate = value[1].set({ hour: 23, minute: 59, second: 59 });
    dispatch({
      type: 'SET_DATE_RANGE',
      payload: {
        pointId: point?.id!,
        datasetId: props.item.datasetId,
        startDate: startDate,
        endDate: endDate,
      },
    });
    getPrice(startDate.format(DTFullFormat), endDate.format(DTFullFormat));

    const obj = Object.assign(props.item, { dateRange: value });
    onDatasetValueChange(obj);
  }

  function disabledDate(current: Moment) {
    if (context.userGroupPermissions === null) {
      return false;
    }
    // Can not select days outside dataset's time range
    return (
      (current && current.isBefore(context.userGroupPermissions.dateRange[0], 'day')) ||
      (current && current.isAfter(context.userGroupPermissions.dateRange[1], 'day'))
    );
  }

  async function addToCart() {
    if (datasetIsOffline) {
      props.setDatasetIsOfflineWarningVisible(true);
      return;
    }
    if (point === undefined || !point.label) {
      message.warn('Please give the active point a name');
      return;
    }

    setCartLoading(true);

    // If cart already contains a point with same name and category we need to prevent the API call and
    // ask theuser to rename current point or delete existing point from cart
    let pointIsInCard = false;
    if (point) {
      const name = point.label;
      const pointWithSameNameIsInCard = Object.keys(
        context.shoppingItems
      ).includes(name);
      if (pointWithSameNameIsInCard) {
        const itemsPerPoint = context.shoppingItems[name];
        pointIsInCard = itemsPerPoint[props.label] !== undefined;
      }
      if (pointIsInCard) {
        message.error(getPointNamInCartError(name));
      } else {
        const extractSubset = await Api.service.createSubsetExtractionTask(
          props.item.datasetId,
          props.item.dateRange[0].format(DTFullFormat),
          props.item.dateRange[1].format(DTFullFormat),
          props.coords,
          point ? point.label : '',
          context.cellSize[props.namePanel].toString(),
          context.depth[props.namePanel].toString(),
          context.datasetBriefs,
          context.fwePoints,
        );
        if (
          extractSubset &&
          extractSubset.Result &&
          extractSubset.Result.OrderIdList &&
          extractSubset.Result.OrderIdList.length > 0
        ) {
          await props.onAddProductToCart(
            props.item,
            point.label,
            props.label,
            extractSubset.Result.OrderIdList[0],
            price,
            props.coords
          );
        } else {
          message.error('Failed to prepare data');
        }
      }
    }
    setCartLoading(false);
  }

  function handleAddToCart() {
    if (!isAuthorized) {
      context.setShowLogin(true);
      return;
    }
    addToCart()
  }

  async function removeFromCart() {
    if (point === undefined || !point.label) {
      return;
    }
    setCartLoading(true);
    await props.onRemoveProductFromCart(point?.label, props.label);
    setCartLoading(false);
  }

  function handleRemoveFromCart() {
    if (!isAuthorized) {
      context.setShowLogin(true);
      return;
    }
    removeFromCart()
  }

  const abortControllerRef = useRef<AbortController | null>(null);

  async function download(typeInput: 'parameters' | '2DSpectra') {
    props.setDisableDownload(true);
    setShowWarn(false);
    handleDownloadModalCancel();

    if (datasetIsOffline) {
      props.setDatasetIsOfflineWarningVisible(true);
      return;
    }
    if (point === undefined || !point.label) {
      message.warn('Please give the active point a name');
      return;
    }

    if (point) {

      const fileFormats = downloadValues.join('|');
      abortControllerRef.current?.abort;
      abortControllerRef.current = new AbortController();
      const signal = abortControllerRef.current.signal;

      let result = null;
      if (typeInput === 'parameters') {
        setShowCancelDownloadButtonParameters(true);

        const extractSubset = await Api.service.createSubsetExtractionTask(
          props.item.datasetId,
          props.item.dateRange[0].format(DTFullFormat),
          props.item.dateRange[1].format(DTFullFormat),
          props.coords,
          point ? point.label : '',
          context.cellSize[props.namePanel].toString(),
          context.depth[props.namePanel].toString(),
          context.datasetBriefs,
          context.fwePoints,
        );

        const shoppingCardDetails = createDownloadOrderString(
          props.item,
          props.label,
          props.coords,
          fileFormats ? fileFormats : 'csv',
          price
        );

        const extractionRequestIds = [extractSubset.Result.OrderIdList[0]];

        result = await Api.moodV2Order.getDirectDownload(
          signal,
          shoppingCardDetails,
          fileFormats ? fileFormats : 'csv',
          extractionRequestIds,
          true
        );

        if (signal && signal.aborted) {
          return;
        }

        if (result.Result !== null) {
          const a = document.createElement('a');
          a.href = result.Result;
          a.click();
        }
      }

      if (typeInput === '2DSpectra') {
        setShowCancelDownloadButton2DSpectre(true);

        const datasetName = props.item.datasetId;
        const startDate = props.item.dateRange[0].format(DTFullFormat);
        const endDate = props.item.dateRange[1].format(DTFullFormat);
        const location = props.coords.toString();
        const pointName = point.label;
        const gridCellSize = context.cellSize[props.namePanel].toString();
        const waterDepth = context.depth[props.namePanel].toString();
        const formatExtension = fileFormats;

        result = await Api.moodV2Order.createWavesSpectraData(
          signal,
          datasetName,
          startDate,
          endDate,
          location,
          pointName,
          gridCellSize,
          waterDepth,
          formatExtension
        );

        if (signal && signal.aborted) {
          return;
        }

        if (result.Result) {
          setIsDownloadSpectraModalVisible(true);
        }
      }

      props.setDisableDownload(false);
      setShowCancelDownloadButtonParameters(false);
      setShowCancelDownloadButton2DSpectre(false);
    }
  }

  function onDatasetValueChange(item: DownloadInfoItem) {
    const idx = point!.downloadPage!.findIndex(
      (d) => d.radioKey === item.radioKey
    );
    if (idx < 0) {
      return;
    }

    if (point !== undefined) {
      point.downloadPage[idx] = item;
      context.setMarkerCollections([...context.markerCollections]);
    }
  }

  const [downloadValues, setDownloadValues] = useState<CheckboxValueType[]>([]);
  const [downloadOptions, setDownloadOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const downloadOptionsParameters = [
    { label: '.csv', value: 'csv' },
    { label: '.mat', value: 'mat' },
    { label: '.nc', value: 'nc' },
    { label: '.dfs0', value: 'dfs0' },
  ];

  const downloadOptions2DSpectra = [
    { label: '.nc', value: 'nc' },
    { label: '.mat', value: 'mat' },
    { label: '.dfs2', value: 'dfs2' },
  ];

  function onChangeDownloadOptions(checkedList: CheckboxValueType[]) {
    setDownloadValues(checkedList);
  }

  function onPolicyRadioChange(e: RadioChangeEvent) {
    setCheckPolicy(e.target.checked);
    setShowWarn(false);
  }

  function findLabel(
    shapeFiles: MarkerItem['shapeFiles'] | undefined,
    label: string
  ) {
    if (!shapeFiles) return false;
    return shapeFiles.some((shapeFile) => shapeFile.Level2 === label);
  }

  const has2DSpectra = useMemo(() => {
    return (
      findLabel(point?.shapeFiles, THOWDWAVESPECTRA) &&
      props.label === DATASET_CATEGORIES.WAVES
    );
  }, [point?.shapeFiles, props.item.datasetId, props.coords]);

  const [show2DSpectra, setShow2DSpectra] = useState(false);

  useEffect(() => {
    // * Load overlay geojson and assign it to active point
    async function getGeoJson(
      shape: overlay,
      options: { isMounted?: { current: boolean } } = {}
    ) {
      const { isMounted } = options
      if (shape && shape?.data === undefined) {
        shape!.data = await Api.fileEndPoint.getOverlayGeoJson(
          point!.dataset,
          shape.Level1,
          shape.Level2,
          shape.LegendColor[0]
        );
        context.setMarkerCollections([...context.markerCollections]);
      }
      if (isMounted?.current) {
        // Check if active point is within Spectra data coverage polygons
        if (shape.data) {
          const polys = shape.data.map(poly => [poly.coordinates as Position[]]);
          const multipolygon = multiPolygon(polys);
          const activePoint = points([props.coords]);
          const pointsWithin = pointsWithinPolygon(activePoint, multipolygon);
          setShow2DSpectra(pointsWithin && pointsWithin.features && pointsWithin.features.length > 0);
        }
        else {
          setShow2DSpectra(false);
        }
      }
    }
    if (has2DSpectra) {
      const shape = point?.shapeFiles.find(
        (x) => x.Level2 === THOWDWAVESPECTRA
      );
      if (shape) {
        const isMounted = { current: true }
        // Make sure that Spectra data coverage polygons are loaded
        withLoading(() => getGeoJson(shape, { isMounted }), loadingContext, { source: 'DownloadInfo.tsx - getGeoJson' });
        // Cleanup function
        return () => {
          isMounted.current = false; // Set the flag to false when the component is unmounted
        };
      }
    }
  }, [point, has2DSpectra, props.coords]);



  const [downloadType, setDownloadType] = useState<
    'parameters' | '2DSpectra' | null
  >(null);

  function startDownloadProcess(type: 'parameters' | '2DSpectra') {
    if (type === 'parameters') {
      setDownloadValues(['csv']);
      setDownloadOptions(downloadOptionsParameters);
    }
    if (type === '2DSpectra') {
      setDownloadValues(['nc']);
      setDownloadOptions(downloadOptions2DSpectra);
    }

    setDownloadType(type);
    setIsDownloadModalVisible(true);
  }

  const cancelDownload = () =>
    abortControllerRef.current && abortControllerRef.current.abort();

  function handleCancelDownload(type: 'parameters' | '2DSpectra') {
    cancelDownload();

    if (type === 'parameters') {
      setShowCancelDownloadButtonParameters(false);
    }
    if (type === '2DSpectra') {
      setShowCancelDownloadButton2DSpectre(false);
    }

    props.setDisableDownload(false);
  }

  function resetDownloadProcess() {
    setDownloadType(null);
    setDownloadValues([]);
    setDownloadOptions([]);
  }

  function handleChangePanelCategory(item: string | string[]) {
    context.setActiveCategoryKey(((prevState: { [key: string]: string | string[] }) => ({
      ...prevState,
      [point!.id]: item
    })))
  }

  return (
    <>
      <Modal
        visible={context.isChangeDatasetWarningVisible[props.namePanel]}
        onOk={handleChangeDatasetWarningOk}
        onCancel={handleChangeDatasetWarningCancel}
      >
        <p>
          Changing the dataset will reset your validation and analytics.
          Continue?
        </p>
      </Modal >
      <DownloadDataModal isVisible={isDownloadSpectraModalVisible} setIsVisible={setIsDownloadSpectraModalVisible} />
      <Modal
        visible={isTNSDatasetWarningVisible}
        footer={null}
        onOk={handleTNSDatasetWarningClose}
        onCancel={handleTNSDatasetWarningClose}
      >
        <div className={styles.modal}>
          <div>This dataset is not yet approved by RVO and certified.</div>Use
          at your own risk.<div></div>{' '}
        </div>
      </Modal>
      <Modal
        className="download-modal"
        title={'Download'}
        visible={isDownloadModalVisible}
        onCancel={() => {
          props.setDisableDownload(false);
          setShowWarn(false);
          handleDownloadModalCancel();
        }}
        onOk={() => {
          if (checkPolicy && downloadType) {
            download(downloadType);
            resetDownloadProcess();
          } else {
            setShowWarn(true);
          }
        }}
      >
        <div className={styles.fileFormats}>
          <p>Select file format(s) of time series data:</p>
          <Checkbox.Group
            key={new Date().getTime()}
            options={downloadOptions}
            defaultValue={downloadValues}
            onChange={onChangeDownloadOptions}
          />
          <div className={styles.policyContainer}>
            <p
              className={
                styles.summaryInfo + ` ${showWarn && styles.summaryWarn}`
              }
            >
              <Checkbox
                defaultChecked={checkPolicy}
                onChange={onPolicyRadioChange}
              >
                <span>
                  I accept the{' '}
                  <span
                    className={styles.summarySpecialText}
                    onClick={openEULAPdf}
                  >
                    General EULA
                  </span>{' '}
                  and{' '}
                  <span
                    className={styles.summarySpecialText}
                    onClick={openPrivatePolicy}
                  >
                    Privacy Policy
                  </span>
                </span>
                {showWarn && (
                  <Fragment>
                    <br />
                    <span className={styles.summaryWarnText}>
                      Please tick checkbox to download.
                    </span>
                  </Fragment>
                )}
              </Checkbox>
            </p>
          </div>
        </div>
      </Modal>
      <Collapse
        accordion
        activeKey={point && context.activeCategoryKey?.[point.id] ? context.activeCategoryKey[point.id] : DownloadCheckboxKey.SW}
        onChange={handleChangePanelCategory}
        className={styles.customCollapse}
      >
        <Collapse.Panel
          className={styles.datasetItem}
          header={
            <Label
              label={
                <div className={styles.DatasetCategory}>
                  {props.icon}
                  <div className={styles.DatasetCategoryLabel}>
                    <h2>{props.label}</h2>
                    {getCategoryPostfix(props.label)}
                  </div>
                </div>
              }
            />
          }
          key={props.namePanel}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Label
                label={
                  <div className={styles.DatasetMetadata}>
                    <div>
                      <b>Model Data</b>
                    </div>
                    <Button className={styles.buttonBorder} type="default" onClick={onShowMetadata}>
                      <div className={styles.buttonContent}>
                        <Metadata width={30} height={30} viewBox={"0 0 40 40"} />
                        <div className={styles.buttonLabel}>Metadata</div>
                      </div>
                    </Button>
                  </div>
                }
              >
                <Select
                  value={props.item && props.item.datasetId}
                  className={styles.InfoSelect}
                  onChange={onDatasetChange}
                  disabled={
                    isEmpty(props.item && props.item.datasetId) || addedToCart
                  }
                >
                  {props.item &&
                    props.item.options.map((item) => {
                      return (
                        <Select.Option key={item.id} value={item.id}>
                          {item.value}
                        </Select.Option>
                      );
                    })}
                </Select>
                {props.label === DATASET_CATEGORIES.WAVES && (
                  <Button className={styles.DatasetFWE} type="link" href={Api.FWE_URL} target="_blank" rel="noopener">
                    Get local model data from MIKE MS
                  </Button>
                )}
              </Label>
            </Col>
            <Col span={12}>
              <Label
                label={
                  <div className={styles.DateLabel}>
                    <span style={{ flexBasis: '50%' }}>Start Date</span>
                    <span>End Date</span>
                  </div>
                }
              >
                <RangePicker
                  value={props.item && props.item.dateRange}
                  disabledDate={disabledDate}
                  format={dateFormatList}
                  style={{ width: '100%' }}
                  onChange={onDateChange}
                  disabled={
                    isEmpty(props.item && props.item.datasetId) || addedToCart
                  }
                />
              </Label>
            </Col>
            {!hasDatasets ? (
              <Col span={18} className={styles.InfoCol}>
                <Label
                  label={'No dataset found (point is outside of coverage)'}
                  className={styles.InfoColLabel}
                >
                  {''}
                </Label>
              </Col>
            ) : (
              <Col span={12} className={styles.InfoCol}>
                {props.item && props.item.radioKey === 'Wind' ? (
                  <div className={styles.InfoColLabel}>{''}</div>
                ) : (
                  <Label
                    label="Water depth [mMSL]"
                    className={styles.InfoColLabel}
                  >
                    <div className={styles.InfoLabel}> {context.depth[props.namePanel]}</div>
                  </Label>
                )}
                <Label
                  label="Grid cell size [m]"
                  className={styles.InfoColLabelRight}
                >
                  <div className={styles.InfoLabel}> {context.cellSize[props.namePanel]}</div>
                </Label>
              </Col>
            )}
            {/* <Add to Cart> & Download Button */}
            <Col span={12} className={styles.priceRegion}>
              <Row gutter={16} className={styles.rowHedder}>
                {show2DSpectra && <Col span={7}>Category</Col>}
                <Col span={7}>
                  Price [EUR]
                </Col>
              </Row>
              {hasDatasets && (
                <Row
                  gutter={16}
                  justify="space-between"
                  align="middle"
                  className={styles.rowBody}
                >
                  {show2DSpectra ? (
                    <Col span={9} className={styles.colText}>
                      Parameters
                    </Col>
                  ) : (
                    <></>
                  )}
                  <Col span={5} className={styles.colPrice}>
                    {price == 0 && isTnw ? 'Free' : `${price},-`}
                  </Col>
                  <Col span={10} className={styles.buttonRow}>
                    {showDownloadButton ? (
                      <DownloadButton
                        showCancelDownloadButton={
                          showCancelDownloadButtonParameters
                        }
                        startDownloadProcess={() =>
                          startDownloadProcess('parameters')
                        }
                        disableDownloadButtons={props.disableDownload}
                        handleCancelDownload={() =>
                          handleCancelDownload('parameters')
                        }
                      />
                    ) : (
                      <BuyButton
                        addedToCart={addedToCart}
                        addToCart={handleAddToCart}
                        removeFromCart={handleRemoveFromCart}
                        cartLoading={cartLoading}
                        hasDatasets={hasDatasets}
                      />
                    )}
                  </Col>
                </Row>
              )}
              {hasDatasets && show2DSpectra && (
                <Row
                  gutter={16}
                  justify="space-between"
                  align="middle"
                  className={styles.rowBody}
                >
                  <Col span={9} className={styles.colText}>
                    2D Spectra
                  </Col>
                  <Col span={5} className={styles.colPrice}>
                    {price == 0 && isTnw ? 'Free' : `${price},-`}
                  </Col>
                  <Col span={10} className={styles.buttonRow}>
                    <DownloadButton
                      showCancelDownloadButton={
                        showCancelDownloadButton2DSpectre
                      }
                      startDownloadProcess={() => {
                        if (!isAuthorized) {
                          context.setShowSpectraModal(true)
                          return;
                        }

                        startDownloadProcess('2DSpectra');
                      }}
                      disableDownloadButtons={context.user.authenticated ?
                        (props.disableDownload ||
                          (!context.userGroupPermissions?.spectraAccess &&
                            !showDownloadButton)) : false}
                      handleCancelDownload={() =>
                        handleCancelDownload('2DSpectra')
                      }
                    />
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Collapse.Panel>
      </Collapse>
    </>
  );
}
